<template>
  <div class="CallScreen" @mouseover="showButtons = true" @mouseleave="showButtons = false">
    <transition name="fade-now">
      <Settings v-if="activeSetting" @closeSetting="closeSetting" />
    </transition>
    <section class="CallScreen__videos" :class="{ 'CallScreen__videos--blur': turnOffWindow }">
      <div ref="localVideoContainer" v-dragged="onDragged" class="CallScreen__video-container">
        <video
          id="localVideo"
          ref="localVideo"
          class="CallScreen__small-video"
          :class="{ 'CallScreen__small-video--active': video }"
          playsinline
          autoplay
          muted
        ></video>
      </div>
      <video id="remoteVideo" ref="remoteVideo" class="CallScreen__big-video" playsinline autoplay></video>
      <transition name="fade-now">
        <div v-if="!videoModeCall" class="CallScreen__container-audio">
          <img
            v-fallback-src="
              require('./../static/images/default-user-avatar.jpg')
            "
            :src="avatarUrl()"
            class="CallScreen__container-audio-background"
          />
          <div class="CallScreen__container-audio-info">
            <img
              v-fallback-src="
                require('./../static/images/default-user-avatar.jpg')
              "
              :src="avatarUrl()"
              class="CallScreen__container-audio-avatar"
            />
            <div
              v-if="
                secondUserData &&
                  secondUserData.user &&
                  secondUserData.user.name
              "
              class="CallScreen__container-audio-user-name"
            >{{ secondUserData.user.name }}</div>
            <div class="CallScreen__container-audio-time">{{ time }}</div>
            <div v-if="callStatus && isCaller" class="CallScreen__container-status">
              {{ callStatus }}
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <section
      class="CallScreen__navigation"
      :class="{
        'CallScreen__navigation--active': showButtons && !turnOffWindow,
      }"
    >
      <div v-if="video" class="CallScreen__button-container" @click="turnOffVideo">
        <div class="CallScreen__button">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_video-off.svg" />
        </div>
        <span class="CallScreen__button-title">Video Off</span>
      </div>
      <div v-if="!video" class="CallScreen__button-container" @click="turnOnVideo">
        <div class="CallScreen__button">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_video-on.svg" />
        </div>
        <span class="CallScreen__button-title">Video On</span>
      </div>
      <div v-if="audio" class="CallScreen__button-container" @click="turnOffMicro">
        <div class="CallScreen__button">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_call_unmute.svg" />
        </div>
        <span class="CallScreen__button-title">Mute</span>
      </div>
      <div v-if="!audio" class="CallScreen__button-container" @click="turnOnMicro">
        <div class="CallScreen__button">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_call_mute.svg" />
        </div>
        <span class="CallScreen__button-title">Unmute</span>
      </div>
      <div class="CallScreen__button-container">
        <div class="CallScreen__button CallScreen__button-red" @click="decline">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_phone-end.svg" />
        </div>
        <span class="CallScreen__button-title">End Call</span>
      </div>
      <div class="CallScreen__button-container" @click="activeSetting = true">
        <div class="CallScreen__button">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_settings.svg" />
        </div>
        <span class="CallScreen__button-title">Settings</span>
      </div>
      <div class="CallScreen__button-container" @click="activeFullScreen">
        <div class="CallScreen__button">
          <img class="CallScreen__button-icon" src="./../static/icons/ic_fullscreen.svg" />
        </div>
        <span class="CallScreen__button-title">Fullscreen</span>
      </div>
    </section>
    <transition name="fade">
      <section v-if="turnOffWindow" class="CallScreen__opinion-container">
        <div class="CallScreen__opinion-title">How was the quality of this call?</div>
        <div class="CallScreen__opinion-buttons-container">
          <div class="CallScreen__opinion-button">
            <button
              class="CallScreen__opinion-button-icon"
              @click="choiceOpinion('UNACCEPTABLE')"
              @mouseover="iconSad = true"
              @mouseleave="iconSad = false"
            >
              <transition name="fade-now">
                <img v-if="!iconSad" src="./../static/icons/sad.svg" />
              </transition>
              <transition name="fade-now">
                <img v-if="iconSad" src="./../static/icons/sad-full.svg" />
              </transition>
            </button>
            <div class="CallScreen__opinion-button-title">Unacceptable</div>
          </div>
          <div class="CallScreen__opinion-button">
            <button
              class="CallScreen__opinion-button-icon"
              @click="choiceOpinion('OKAY')"
              @mouseover="iconNormal = true"
              @mouseleave="iconNormal = false"
            >
              <transition name="fade-now">
                <img v-if="!iconNormal" src="./../static/icons/normal.svg" />
              </transition>
              <transition name="fade-now">
                <img v-if="iconNormal" src="./../static/icons/normal-full.svg" />
              </transition>
            </button>
            <div class="CallScreen__opinion-button-title">Okay</div>
          </div>
          <div class="CallScreen__opinion-button">
            <button
              class="CallScreen__opinion-button-icon"
              @click="choiceOpinion('EXCELLENT')"
              @mouseover="iconHappy = true"
              @mouseleave="iconHappy = false"
            >
              <transition name="fade-now">
                <img v-if="!iconHappy" src="./../static/icons/happy.svg" />
              </transition>
              <transition name="fade-now">
                <img v-if="iconHappy" src="./../static/icons/happy-full.svg" />
              </transition>
            </button>
            <div class="CallScreen__opinion-button-title">Excellent</div>
          </div>
        </div>
      </section>
    </transition>
    <transition name="fade">
      <button
        v-if="turnOffWindow"
        class="CallScreen__opinion-exit-button"
        @click="choiceOpinion('UNKNOWN')"
      >Close Window</button>
    </transition>
    <div
      class="CallScreen__ads-container"
      :class="{'CallScreen__ads-container--active': turnOffWindow}"
    >
      <ins
        class="adsbygoogle CallScreen__ads"
        style="display:inline-block;"
        data-ad-format="fluid"
        data-ad-layout-key="-fc+50+9g-c8-9k"
        data-ad-client="ca-pub-4219078520477774"
        data-ad-slot="9081474448"
        data-full-width-responsive="true"
      />
    </div>
    <div v-if="videoModeCall" class="CallScreen__user-info-container">
      <div class="CallScreen__user-avatar-container">
        <img
          v-fallback-src="require('./../static/images/default-user-avatar.jpg')"
          :src="avatarUrl()"
          class="CallScreen__avatar"
        />
      </div>
      <div class="CallScreen__call-info">
        <div
          v-if="
            secondUserData && secondUserData.user && secondUserData.user.name
          "
          class="CallScreen__user-name"
        >{{ secondUserData.user.name }}</div>
        <div v-if="turnOffWindow" class="CallScreen__call-ended">Call Ended</div>
        <div v-if="!turnOffWindow" class="CallScreen__call-time">{{ time }}</div>
      </div>
    </div>
    <img v-if="!videoModeCall" src="./../static/icons/ic_kc-logo.svg" class="CallScreen__logo" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Vue from 'vue'
import Settings from './Settings.vue'
import VDragged from 'v-dragged'
import fallbackSrc from './../directives/fallback-src.directive'
import { setTimeout } from 'timers'
import outgoingCallAudio from '../static/audios/outgoing-call.wav'
import toneEndAudio from '../static/audios/tone-end-small.wav'
import outgoingConnectingCallAudio from '../static/audios/outgoing-connecting.wav'

Vue.use(VDragged)

export default {
  name: 'CallScreen',

  directives: {
    fallbackSrc,
  },

  components: {
    Settings,
  },

  props: {
    videoModeCall: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      video: false,
      audio: true,
      endedCall: false,
      showButtons: false,
      time: null,
      minutes: 0,
      seconds: 0,
      hours: 0,
      iconSad: false,
      iconNormal: false,
      iconHappy: false,
      activeSetting: false,
      toneEnd: new Audio(toneEndAudio),
      outgoingCall: new Audio(outgoingCallAudio),
      outgoingConnectingCall: new Audio(outgoingConnectingCallAudio),
    }
  },

  computed: {
    ...mapState({
      videoCall: state => state.call.videoCall,
      turnOffWindow: state => state.call.turnOffWindow,
      secondUserData: state => state.call.secondUserData,
      isCaller: state => state.call.isCaller,
      localStream: state => state.webRTC.localStream,
      videoDeviceId: state => state.webRTC.videoDeviceId,
      audioDeviceId: state => state.webRTC.audioDeviceId,
      callStatus: state => state.call.callStatus,
    }),
  },

  watch: {
    turnOffWindow() {
      this.endedCall = true
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    },
    videoModeCall(newVal) {
      if (newVal) {
        this.removeVideo()
        this.setLocalVideo({ localVideo: this.$refs.localVideo })
        this.setRemoteVideo({ remoteVideo: this.$refs.remoteVideo })
      }
    },
    localStream(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.updateVideo()
      }
    },
    callStatus(newVal) {
      if (!newVal && this.isCaller) {
        setInterval(this.timer, 500)
      }

      if (newVal === 'Connecting') {
        this.outgoingConnectingCall.play()
        this.outgoingConnectingCall.loop = true
      } else if (newVal === 'Ringing') {
        this.outgoingConnectingCall.pause()
        this.outgoingCall.play()
        this.outgoingCall.loop = true
      } else if (newVal === 'declineCall') {
        this.outgoingConnectingCall.pause()
        this.outgoingCall.pause()
        this.toneEnd.play()
      } else {
        this.outgoingConnectingCall.pause()
        this.outgoingCall.pause()
      }
    },
  },

  mounted() {
    this.setLocalVideo({ localVideo: this.$refs.localVideo })
    this.setRemoteVideo({ remoteVideo: this.$refs.remoteVideo })
    this.setupLocalStream({ audio: true, video: !!this.videoCall }).then(
      this.connectWebsocket
    )

    this.video = this.videoCall
    if (!this.isCaller) {
      setInterval(this.timer, 1000)
    }

    window.addEventListener('resize', this.getWindowSize)
    window.addEventListener('beforeunload', this.declineCallBeforeUnload)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    window.removeEventListener('beforeunload', this.declineCallBeforeUnload)
  },

  methods: {
    ...mapActions([
      'connectWebsocket',
      'setupLocalStream',
      'getJWTToken',
      'declineCall',
      'updateVideo',
      'addVideo',
      'removeVideo',
      'userOpinion',
      'getUserData',
      'sendRenegotiation',
    ]),
    ...mapMutations([
      'setLocalVideo',
      'setRemoteVideo',
      'getUserInfo',
      'microOn',
      'microOff',
    ]),

    declineCallBeforeUnload() {
      if (!this.turnOffWindow) {
        this.declineCall()
      }
    },

    decline() {
      this.toneEnd.play()
      this.declineCall()
    },

    turnOffVideo() {
      if (!this.isCaller) {
        this.sendRenegotiation()
      }
      this.video = false
      this.removeVideo()
    },

    turnOnVideo() {
      this.video = true
      this.setupLocalStream({
        audio: this.audio,
        video: this.video,
      })
      if (!this.isCaller) {
        this.sendRenegotiation()
      }
      setTimeout(this.addVideo(), 1000)
    },

    turnOffMicro() {
      this.audio = false
      this.microOff()
    },

    turnOnMicro() {
      this.audio = true
      this.microOn()
    },

    choiceOpinion(userExperience) {
      // // OS Name
      // let osName = 'Unknown'
      // if (window.navigator.userAgent.indexOf('Windows NT 10.0') !== -1)
      //   osName = 'Windows 10'
      // if (window.navigator.userAgent.indexOf('Windows NT 6.2') !== -1)
      //   osName = 'Windows 8'
      // if (window.navigator.userAgent.indexOf('Windows NT 6.1') !== -1)
      //   osName = 'Windows 7'
      // if (window.navigator.userAgent.indexOf('Windows NT 6.0') !== -1)
      //   osName = 'Windows Vista'
      // if (window.navigator.userAgent.indexOf('Windows NT 5.1') !== -1)
      //   osName = 'Windows XP'
      // if (window.navigator.userAgent.indexOf('Mac') !== -1) osName = 'Mac/iOS'
      // if (window.navigator.userAgent.indexOf('X11') !== -1) osName = 'UNIX'
      // if (window.navigator.userAgent.indexOf('Linux') !== -1) osName = 'Linux'

      // // browser name
      // let ua = navigator.userAgent
      // let x = ua.indexOf('MSIE')
      // let browserName = ''
      // if (x === -1) {
      //   x = ua.indexOf('Firefox')
      //   if (x === -1) {
      //     if (x === -1) {
      //       x = ua.indexOf('Chrome')
      //       browserName = 'Chrome'
      //       if (x === -1) {
      //         x = ua.indexOf('Opera')
      //         browserName = 'Opera'
      //         if (x === -1) {
      //           x = ua.indexOf('Safari')
      //           browserName = 'Safari'
      //           if (x !== -1) {
      //             x = ua.indexOf('Version')
      //             browserName = 'Version'
      //           }
      //         }
      //       }
      //     }
      //   }
      // }

      // let data = {
      //   userExperience: userExperience,
      //   deviceInfo: {
      //     os: osName,
      //     model: browserName,
      //   },
      // }

      // this.userOpinion(data)
      window.close()
    },

    timer() {
      let seconds = `0${this.seconds}`
      let minutes = `${this.minutes}`
      let hours = `0${this.hours}`

      this.seconds++

      if (this.seconds < 10) {
        seconds = `0${this.seconds}`
      } else {
        seconds = this.seconds
      }

      if (this.seconds === 60) {
        this.seconds = 0
        seconds = '00'
        this.minutes++
        minutes = this.minutes
      }

      if (this.minutes >= 60) {
        this.minutes = 0
        this.seconds = 0
        this.hours++
        hours = `0${this.hours}`
      }

      if (this.minutes < 10) {
        minutes = `0${this.minutes}`
      }

      if (this.hours > 0) {
        this.time = hours + ':' + minutes + ':' + seconds
      } else {
        this.time = minutes + ':' + seconds
      }
    },

    avatarUrl() {
      if (
        this.secondUserData &&
        this.secondUserData.user &&
        this.secondUserData.user.avatarUrl
      ) {
        return this.secondUserData.user.avatarUrl
      }

      return require('../static/images/default-user-avatar.jpg')
    },

    activeFullScreen() {
      if (document.fullscreenElement) {
        // fullscreen is activated
        document.exitFullscreen()
      } else {
        // fullscreen is cancelled
        document.documentElement.requestFullscreen()
      }
    },

    getWindowSize() {
      this.$refs.localVideoContainer.style.top = 20 + 'px'
      this.$refs.localVideoContainer.style.left = window.innerWidth - 191 + 'px'
    },

    onDragged({
      el,
      deltaX,
      deltaY,
      offsetX,
      offsetY,
      clientX,
      clientY,
      first,
      last,
    }) {
      if (first) {
        this.isDragging = true
        return
      }
      if (last) {
        this.isDragging = false
        return
      }
      var l = +window.getComputedStyle(el)['left'].slice(0, -2) || 0
      var t = +window.getComputedStyle(el)['top'].slice(0, -2) || 0
      el.style.top = t + deltaY + 'px'
      el.style.left = l + deltaX + 'px'
      // if element is outside mother (left)
      if (l <= 20) {
        el.style.left = 21 + 'px'
      }
      // if element is outside mother (right)
      if (l > window.innerWidth - 190) {
        el.style.left = window.innerWidth - 191 + 'px'
      }
      // if element is outside mother (top)
      if (t <= 20) {
        el.style.top = 21 + 'px'
      }
      // if element is outside mother (bottom)
      if (t > window.innerHeight - 148) {
        el.style.top = window.innerHeight - 149 + 'px'
      }
    },
    closeSetting() {
      this.activeSetting = false
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'CallScreen';
</style>
